import { NumberCoercible } from '../utils/NumberCoercible';
import { percentFormatter } from './percentFormatter';

const getSlicePercentValue = (v: NumberCoercible) => {
  if (v > 0.99 && v < 1.0) {
    return 0.99;
  }
  if (v > 0 && v < 0.01) {
    return 0.01;
  }
  return v;
};

/**
 * A percent formatter with adjusted slice ratios for use in labels/legends.
 */
export const labelPercentFormatter = (v: NumberCoercible, locale?: string): string =>
  `${v > 0 && v < 0.01 ? '< ' : ''}${percentFormatter(getSlicePercentValue(v), locale)}`;
